import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { THEME_COLOR } from "../../config/club";
import Swal from "sweetalert2";
import { db } from "../../firebase";
import {
  doc,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { useTheme } from "../../context/ThemeContext";

export default function AppHeader({
  user,
  title,
  subtitle,
  clubId,
  sessionId,
  onLogout,
  logout
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const THEME_VIOLET = THEME_COLOR;
  const { darkMode, setDarkMode } = useTheme();
  const handleProfileClick = () => {
    if (clubId && sessionId) {
      navigate("/me", {
        state: {
          from: "join",
          clubId,
          sessionId,
        },
      });
    } else {
      navigate("/me");
    }
  };
  const handleLogout = async () => {
    const result = await Swal.fire({
      title: "Logout?",
      html: "Are you sure you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#f0f0f0",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    try {
      if (clubId && sessionId && user?.uid) {
        // Remove from queue first
        // await deleteDoc(
        //     doc(db, "clubs", clubId, "sessions", sessionId, "queue", user.uid)
        // );
        await updateDoc(doc(db, "clubs", clubId, "sessions", sessionId, "players", user.uid), { status: "left", leftAt: serverTimestamp() });
      }
      await logout();
      // Navigation usually happens automatically via AuthContext/Protected Routes
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to logout properly", "error");
    }
  };

  return (
    <>
      <div
        style={{
          background: `linear-gradient(135deg, ${THEME_VIOLET} 0%, #4C1D95 100%)`,
          borderBottom: "1px solid rgba(255,255,255,0.1)",
        }}
        className="py-3"
      >
        <div className="container d-flex align-items-center justify-content-between">

          {/* LEFT */}
          <div className="d-flex align-items-center gap-2 overflow-hidden">
            <img
              src="/img/rrc.png"
              alt="Logo"
              style={{ height: "36px" }}
            />

            <div className="overflow-hidden">
              <h6
                className="mb-0 fw-bold text-truncate"
                style={{
                  fontSize: "0.95rem",
                  letterSpacing: "-0.02em",
                  color: "#ffffff",
                  textShadow: "0 1px 2px rgba(0,0,0,0.25)"
                }}
              >
                {title || "Racket Riot Club"}
              </h6>

              {subtitle && (
                <div
                  className="text-truncate"
                  style={{
                    fontSize: "0.72rem",
                    color: "rgba(255,255,255,0.85)",
                    letterSpacing: "0.3px"
                  }}
                >
                  {subtitle}
                </div>
              )}
            </div>
          </div>

          {/* RIGHT */}
          <div className="d-flex align-items-center gap-2">

            {/* Theme Toggle */}
            <button
              onClick={() => setDarkMode(!darkMode)}
              style={{
                width: "38px",
                height: "38px",
                borderRadius: "12px",
                background: "rgba(255,255,255,0.15)",
                border: "1px solid rgba(255,255,255,0.25)",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backdropFilter: "blur(10px)",
                transition: "all 0.2s ease",
              }}
            >
              <i className={`bi ${darkMode ? "bi-sun-fill" : "bi-moon-stars-fill"}`} />
            </button>

            {/* Logout */}
            <button
              onClick={handleLogout}
              style={{
                width: "38px",
                height: "38px",
                borderRadius: "12px",
                background: "rgba(255,255,255,0.08)",
                border: "1px solid rgba(255,255,255,0.15)",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.2s ease"
              }}
            >
              <i className="bi bi-power" />
            </button>

          </div>
        </div>
      </div>
    </>
  );
}
